module.exports = __webpack_public_path__ + "static/img/IS.8c44cbe4.png";